import { useTranslation } from "react-i18next";
import useAuthentication from "./useAuthentication";
import { loggUt } from "./auth.utils";
import { useState } from "react";
import styles from "./auth.module.scss";
import { useOutsideClick } from "../hooks/useOutsideClick";
import Button from "../components/button/Button";
import cn from "classnames";
import { Languages } from "../i18n/config";

const LoginBar = ({ lang }: { lang: Languages }) => {
  const { t } = useTranslation("skjematekst", { keyPrefix: "auth.min_profil" });
  const { userInfo } = useAuthentication();
  const navn = userInfo?.name;
  const ariaLabel = userInfo ? t("ariaLabel") : t("kontaktInfo");
  return (
    <nav className={styles.loginBarContainer} aria-label={ariaLabel}>
      <div className={styles.loginBar}>
        {userInfo !== null ? (
          <MinProfilDropdown username={navn || ""} />
        ) : (
          // Custom web component som kommer fra politiet.no
          <pno-contact-points lang={lang}></pno-contact-points>
        )}
      </div>
    </nav>
  );
};

type MinProfilDropdownProps = {
  username: string;
};
const MinProfilDropdown = ({ username }: MinProfilDropdownProps) => {
  const [isOpen, setIsOpen] = useState<boolean>();
  const { t } = useTranslation("skjematekst", { keyPrefix: "auth.min_profil" });
  return (
    <div
      className={styles.minProfilDropdownContainer}
      ref={useOutsideClick(() => setIsOpen(false))}
    >
      <div className={styles.profileTab}>
        <Button
          icon={"account_circle"}
          text={username}
          buttonType={"tertiary"}
          onClick={() => setIsOpen(!isOpen)}
          className={cn(styles.fillContainerButton, styles.profileButton)}
          textModifierClass={styles.profileButtonText}
          trackingName={"Min profil"}
        />
        <sds-icon
          name={
            isOpen
              ? "keyboard_arrow_up-material-outlined"
              : "keyboard_arrow_down-material-outlined"
          }
        />
      </div>
      <div className={cn(styles.navButtons, isOpen && styles.open)}>
        <Button
          icon={"logout"}
          onClick={() => loggUt()}
          buttonType={"tertiary"}
          text={t("knapper.logg_ut")}
          className={styles.fillContainerButton}
          trackingName={"Min profil - Logg ut"}
          tabIndex={isOpen ? 0 : -1}
        />
      </div>
    </div>
  );
};

export default LoginBar;
